import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about/about_language_txt_m.svg")